import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { CompanyFilters, CompanySlice } from "./companiesTypes.ts";

const initialState: CompanySlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<CompanySlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<CompanySlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof CompanyFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<CompanySlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  companiesSlice.actions;

export const selectPage = (state: RootState) => state.companies.page;
export const selectRowsPerPage = (state: RootState) =>
  state.companies.rowsPerPage;
export const selectFilter = (state: RootState) => state.companies.filter;
export const selectSort = (state: RootState) => state.companies.sort;

export default companiesSlice.reducer;
